/**
 * Rascunho da consulta em andamento: transcrição, notas, motivo e resumo.
 *
 * POR QUE EXISTE. O `AppointmentDialog` guarda tudo na memória do componente.
 * Recarregar a aba no meio da consulta (F5, aba que o navegador descarta, queda
 * do front) apagava a transcrição inteira — que não se refaz, porque a paciente
 * já foi embora. Mesmo problema que o `comandosDeVozStore` resolveu para os
 * comandos ditos.
 *
 * POR QUE sessionStorage. Sobrevive ao recarregar a aba, que é a falha real, e
 * some ao fechar a aba: texto clínico não fica esquecido no navegador depois do
 * atendimento. Quem fecha a aba gravando é avisado antes (beforeunload).
 *
 * ⚠️ A CHAVE É POR PACIENTE: rascunho de uma paciente aparecendo na consulta de
 * outra é dado clínico no prontuário errado. Nada é lido sem o `patientId`.
 */

const PREFIXO = "salvia.rascunhoConsulta";

/** Rascunho mais velho que isto é descartado na leitura (cobre o dia de trabalho). */
const VALIDADE_MS = 12 * 60 * 60 * 1000;

function chave(patientId) {
  return `${PREFIXO}.${patientId}`;
}

function armazenamento() {
  try {
    return typeof window !== "undefined" ? window.sessionStorage : null;
  } catch (e) {
    // Safari em modo privado lança ao tocar no storage: perder o rascunho é
    // ruim; quebrar a consulta por causa dele seria pior.
    return null;
  }
}

/** Há algo que valha guardar? Consulta aberta e intocada não vira rascunho. */
export function rascunhoTemConteudo(r) {
  return Boolean(
    r && ((r.transcricao && r.transcricao.trim()) || (r.notas && r.notas.length)),
  );
}

/**
 * @param {number|string} patientId
 * @returns {object|null} o rascunho guardado, ou null se não houver, se
 *          expirou ou se o armazenamento não estiver disponível.
 */
export function carregarRascunho(patientId) {
  const s = armazenamento();
  if (!patientId || !s) return null;
  try {
    const bruto = s.getItem(chave(patientId));
    if (!bruto) return null;
    const r = JSON.parse(bruto);
    if (Date.now() - (r.em || 0) > VALIDADE_MS || !rascunhoTemConteudo(r)) {
      limparRascunho(patientId);
      return null;
    }
    return r;
  } catch (e) {
    limparRascunho(patientId);
    return null;
  }
}

export function salvarRascunho(patientId, rascunho) {
  const s = armazenamento();
  if (!patientId || !s) return;
  try {
    if (!rascunhoTemConteudo(rascunho)) {
      s.removeItem(chave(patientId));
      return;
    }
    s.setItem(chave(patientId), JSON.stringify({ ...rascunho, em: Date.now() }));
  } catch (e) {
    // Cota cheia: segue sem rascunho, a consulta continua.
  }
}

export function limparRascunho(patientId) {
  const s = armazenamento();
  if (!patientId || !s) return;
  try {
    s.removeItem(chave(patientId));
  } catch (e) {
    /* sem storage, nada a limpar */
  }
}
